module.exports = __webpack_public_path__ + "static/media/nutritional-counter-app-composition2.48d43668.jpg";